import { UserMinusIcon, UserPlusIcon } from "@heroicons/react/24/outline";
import { displayName, UserId } from "@sp-crm/core";
import React from "react";
import { useRegionId, useUsersForRegion } from "store/selectors/hooks";
import { UserMap } from "store/selectors/users";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

const formatCollaboratorName = (users: UserMap, userId: UserId | null) => {
    if (!userId) {
        return "(unknown user)";
    }
    const user = users[userId];
    if (!user) {
        return "(unknown user)";
    }
    return displayName(user);
};

export const EntityActivityCollaboratorAdded: React.FC<
    EntityActivityEntryProps
> = props => {
    const { activity } = props;
    const currentRegion = useRegionId();
    const users = useUsersForRegion(currentRegion);

    let collaboratorName = "(unknown user)";
    if (activity?.activity?.metadata?.events?.length > 0) {
        const event = activity.activity.metadata.events[0].entityCollaboratorAdded;
        if (event?.collaboratorId) {
            collaboratorName = formatCollaboratorName(users, event.collaboratorId);
        }
    }

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <UserPlusIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    added <strong>{collaboratorName}</strong> as a collaborator.
                </EntityActivitySummary>
            </div>
        </div>
    );
};

export const EntityActivityCollaboratorRemoved: React.FC<
    EntityActivityEntryProps
> = props => {
    const { activity } = props;
    const currentRegion = useRegionId();
    const users = useUsersForRegion(currentRegion);

    let collaboratorName = "(unknown user)";
    if (activity?.activity?.metadata?.events?.length > 0) {
        const event = activity.activity.metadata.events[0].entityCollaboratorRemoved;
        if (event?.collaboratorId) {
            collaboratorName = formatCollaboratorName(users, event.collaboratorId);
        }
    }

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <UserMinusIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    removed <strong>{collaboratorName}</strong> as a collaborator.
                </EntityActivitySummary>
            </div>
        </div>
    );
};
